import { Controller } from "@hotwired/stimulus"

// The offering page program's Sort (TMS-1749). The server renders the list and the cards in
// program order with each session's sort values on its item; picking an option reorders both
// views here, so whichever one is showing is sorted. Nothing is stored — a new visit opens in
// program order.
export default class extends Controller {
  static targets = ["list", "item", "announcement"]
  static values = { default: { type: String, default: "program" } }

  select(event) {
    event.preventDefault()

    const option = event.currentTarget
    this.markSelected(option)
    this.markTrigger(option.dataset.sortValue)
    this.sortBy(option.dataset.sortValue)
    this.announcementTarget.textContent = `Sorted by ${option.textContent.trim()}`
  }

  sortBy(sort) {
    const compare = this.comparators[sort] || this.comparators.program

    this.listTargets.forEach(list => {
      const items = this.itemTargets.filter(item => item.parentElement === list)
      items.sort((first, second) => compare(first.dataset, second.dataset) || byProgram(first.dataset, second.dataset))
      list.append(...items)
    })
  }

  get comparators() {
    return {
      program: byProgram,
      not_started: (first, second) => started(first) - started(second),
      // A session with no length to show — no recording, no schedule — goes last.
      shortest: (first, second) => lastWhenMissing(Number(first.seconds), Number(second.seconds), (a, b) => a - b),
      // A session without a speaker goes last.
      speaker: (first, second) =>
        lastWhenMissing(first.speaker, second.speaker, (a, b) => a.localeCompare(b, "en", { sensitivity: "base" }))
    }
  }

  // The shared popover draws its filled radio from `is-selected`, so moving the class is enough.
  markSelected(option) {
    this.element.querySelectorAll(".filter-popover-option")
      .forEach(each => each.classList.toggle("is-selected", each === option))
  }

  // Like every Sort and filter button, it is tinted while it changes what the page shows.
  markTrigger(sort) {
    const trigger = this.element.querySelector(".filter-popover-trigger")
    if (!trigger) return

    const active = sort !== this.defaultValue
    trigger.classList.toggle("purple-soft-btn", active)
    trigger.classList.toggle("purple-outline-btn", !active)
  }
}

function byProgram(first, second) {
  return Number(first.programIndex) - Number(second.programIndex)
}

function started(values) {
  return values.started === "true" ? 1 : 0
}

function lastWhenMissing(first, second, compare) {
  if (!first && !second) return 0
  if (!first) return 1
  if (!second) return -1
  return compare(first, second)
}
